import React from 'react'

const FooterBottom = () => {
  return (
    <div className="w-full py-7 border-t border-white/5">
      <p className="text-center text-gray-600 text-xs">
        © {new Date().getFullYear()}. All rights reserved.
      </p>
    </div>
  );
}

export default FooterBottom
